"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotPlatformProductToken = exports.TokensEnableState = exports.isCustomToken = exports.isTokenEditable = exports.isListToken = exports.isPopularToken = exports.isToken = void 0;
var lodash_1 = require("lodash");
var TokenTypes = __importStar(require("@CommonFrontendBackend/Tokens/Types"));
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var isToken = function (token) {
    return (0, lodash_1.isObject)(token) && "providerType" in token && "dataType" in token && "apiName" in token && "name" in token;
};
exports.isToken = isToken;
var isPopularToken = function (token) {
    return ((0, lodash_1.isObject)(token) &&
        "providerType" in token &&
        "dataType" in token &&
        "apiName" in token &&
        "name" in token &&
        !("id" in token) &&
        !("ownerId" in token));
};
exports.isPopularToken = isPopularToken;
var isListToken = function (token) {
    return (!!token["dataType"] &&
        [TokenTypes.TokenDataType.List, TokenTypes.TokenDataType.ProductList].includes(token["dataType"]));
};
exports.isListToken = isListToken;
var isTokenEditable = function (token) {
    return token.providerType === TokenTypes.ProviderType.Custom;
};
exports.isTokenEditable = isTokenEditable;
var isCustomToken = function (token) {
    return token.providerType === TokenTypes.ProviderType.Custom;
};
exports.isCustomToken = isCustomToken;
var TokensEnableState;
(function (TokensEnableState) {
    TokensEnableState[TokensEnableState["EnabledWithAllInteractions"] = 0] = "EnabledWithAllInteractions";
    TokensEnableState[TokensEnableState["EnabledWithoutDragAndDrop"] = 1] = "EnabledWithoutDragAndDrop";
    TokensEnableState[TokensEnableState["Disabled"] = 2] = "Disabled";
})(TokensEnableState || (exports.TokensEnableState = TokensEnableState = {}));
var isNotPlatformProductToken = function (token) {
    return !(Types_1.PLATFORM_SUPPORTED_PROVIDER_TYPES.has(token.providerType) && token.dataType === Types_1.TokenDataType.ProductList);
};
exports.isNotPlatformProductToken = isNotPlatformProductToken;
